// 导入axios
import axios from 'axios';

// 进行一些全局配置
// 公共路由(网络请求地址)
// axios.defaults.baseURL = '';
// 请求响应超时时间
axios.defaults.timeout = 5000;

export default {
    get: function (path = '', data = {}) {
        return new Promise(function (resolve, reject) {
            axios.get(path, {
                    params: data
                })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    post: function (path = '', data = {}) {
        return new Promise(function (resolve, reject) {
            axios.post(path, data)
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
};